// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminDiffControlContainer[data-v-68300dfe] {
  padding: 10px 15px;
}
.adminDiffControlContainer .changedKey[data-v-68300dfe],
.adminDiffControlContainer .deletedKey[data-v-68300dfe],
.adminDiffControlContainer .addedKey[data-v-68300dfe] {
  color: white;
}
.adminDiffControlContainer .changedKey[data-v-68300dfe] {
  background: #2568db;
}
.adminDiffControlContainer .deletedKey[data-v-68300dfe] {
  background: #d70015;
}
.adminDiffControlContainer .addedKey[data-v-68300dfe] {
  background: #208337;
}
`, "",{"version":3,"sources":["webpack://./public/pages/Page/Diff.3.vue","webpack://./../Diff.3.vue"],"names":[],"mappings":"AAIA;EACI,kBAAA;ACHJ;ADEA;;;EAKQ,YAAA;ACFR;ADHA;EAQQ,mBAAA;ACFR;ADNA;EAWQ,mBAAA;ACFR;ADTA;EAcQ,mBAAA;ACFR","sourcesContent":["\n@added: #208337;\n@changed: #2568db;\n@deleted: #d70015;\n.adminDiffControlContainer {\n    padding: 10px 15px;\n    .changedKey,\n    .deletedKey,\n    .addedKey {\n        color: white;\n    }\n    .changedKey {\n        background: @changed;\n    }\n    .deletedKey {\n        background: @deleted;\n    }\n    .addedKey {\n        background: @added;\n    }\n}\n",".adminDiffControlContainer {\n  padding: 10px 15px;\n}\n.adminDiffControlContainer .changedKey,\n.adminDiffControlContainer .deletedKey,\n.adminDiffControlContainer .addedKey {\n  color: white;\n}\n.adminDiffControlContainer .changedKey {\n  background: #2568db;\n}\n.adminDiffControlContainer .deletedKey {\n  background: #d70015;\n}\n.adminDiffControlContainer .addedKey {\n  background: #208337;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
